import React, { useEffect, useState } from 'react';
import { TabContext, TabPanel } from '@mui/lab';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Box, Button, Grid, Card, CardContent, Typography } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useSnackbar } from 'notistack';
import { styles } from './styles';
import CompanyTab from './companyTab';
import { useDisplayCompanyMutation } from '../../../api/company';

const AddCompany = (props) => {
    const [view] = useState('user-details');
    const { enqueueSnackbar } = useSnackbar();
    const [isEditMode, setIsEditMode] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const [companyDetails, setCompanyDetails] = useState();

    const [displayCompany, { isLoading }] = useDisplayCompanyMutation();

    useEffect(() => {
        if (id && isEditMode) {
            async function fetchData() {
                const bodyFormData = new FormData();
                bodyFormData.append('id', id);
                try {
                    const response = await displayCompany(bodyFormData).unwrap();
                    if (!response) return;
                    if (response?.status === 'ERROR') throw new Error(response?.message);
                    setCompanyDetails(response);
                } catch (err) {
                    if (err?.statusCode === 400) enqueueSnackbar(err?.data?.message, { variant: 'error' });
                    else
                        enqueueSnackbar(err?.message || 'Something went wrong! Customer could not be fetched.', {
                            variant: 'error',
                        });
                }
            }
            fetchData();
        }
    }, [id, isEditMode]);

    useEffect(() => {
        if (id && location.pathname.includes('/edit')) {
            setIsEditMode(true);
        } else {
            setIsEditMode(false);
        }
    }, [id, location.pathname]);
    return (
        <Box>
            <Box sx={styles.contentHeaderWrapper}>
                <Typography variant="h4">{isEditMode ? 'Edit Customer' : 'Customer onboarding'}</Typography>
            </Box>
            <Box sx={styles.contentBodyWrapper}>
                <Card {...props}>
                    <CardContent>
                        <Grid container direction="column" spacing={2}>
                            <Grid item>
                                <Button
                                    startIcon={<ChevronLeftIcon />}
                                    variant="text"
                                    color="secondary"
                                    onClick={() => navigate('/company')}
                                >
                                    Back
                                </Button>
                            </Grid>
                            <Grid item>
                                <Typography color="textPrimary" variant="h4">
                                    {!!isEditMode && 'Edit '}Company details
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <TabContext value={view}>
                                <TabPanel sx={styles.tabpanel} value={'user-details'}>
                                    <CompanyTab
                                        isEditMode={isEditMode}
                                        address={companyDetails?.address}
                                        company={companyDetails?.company}
                                    />
                                </TabPanel>
                            </TabContext>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default AddCompany;
